import { useEffect, useState } from 'react';
import { CONFIG_CADASTRO_PADRAO, getConfigCadastro } from '../database/configPlataforma';

// Configuração do cadastro público (ver database/configPlataforma.ts). Enquanto carrega, vale o padrão
// (reCAPTCHA desligado), que é o mesmo comportamento de quando o admin nunca mexeu na configuração.
export function useConfigCadastro() {
  const [config, setConfig] = useState(CONFIG_CADASTRO_PADRAO);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;
    getConfigCadastro()
      .then((c) => ativo && setConfig(c))
      .finally(() => ativo && setCarregando(false));
    return () => { ativo = false; };
  }, []);

  return { recaptchaAtivo: config.recaptchaAtivo, pacotesAtivo: config.pacotesAtivo, carregando };
}
